var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEwinMarksixCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/40x40px/eWin-index/M6/calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw-schedule"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0000667,30.0938507 C40.0000667,31.5263047 31.0460517,32.6877013 20.0000333,32.6877013 C8.95468159,32.6877013 0,31.5263047 0,30.0938507 C0,28.6613966 8.95468159,27.5 20.0000333,27.5 C31.0460517,27.5 40.0000667,28.6613966 40.0000667,30.0938507",
    id: "Fill-7",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2ECEC",
    fillRule: "nonzero",
    x: 3.5,
    y: 0,
    width: 33,
    height: 30,
    rx: 3.3402
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,3.00900901 L36.5,6 L3.5,6 L3.5,3.00900901 C3.50292568,1.34839259 4.84839259,0.00292567887 6.50900901,0 L33.490991,0 C35.1516074,0.00292567887 36.4970743,1.34839259 36.5,3.00900901 L36.5,3.00900901 Z",
    id: "Path",
    fill: "#980B0B",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 7,
    y: 11,
    width: 20,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 7,
    y: 17,
    width: 20,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CB7B7B",
    fillRule: "nonzero",
    x: 7,
    y: 23,
    width: 20,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC600",
    fillRule: "nonzero",
    x: 30,
    y: 10.5,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC600",
    fillRule: "nonzero",
    x: 30,
    y: 16.5,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFC600",
    fillRule: "nonzero",
    x: 30,
    y: 22.5,
    width: 3,
    height: 3,
    rx: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwinMarksixCalendar);
export default __webpack_public_path__ + "static/media/ewin_marksix_calendar.24042a3f6a2817d171f354d8d75c5c6f.svg";
export { ForwardRef as ReactComponent };